/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddOrUpdateTrainingProgramExternalDetailsCommand
 */
export interface AddOrUpdateTrainingProgramExternalDetailsCommand {
    /**
     * 
     * @type {string}
     * @memberof AddOrUpdateTrainingProgramExternalDetailsCommand
     */
    url: string;
    /**
     * 
     * @type {number}
     * @memberof AddOrUpdateTrainingProgramExternalDetailsCommand
     */
    durationMinutes: number;
}

export function AddOrUpdateTrainingProgramExternalDetailsCommandFromJSON(json: any): AddOrUpdateTrainingProgramExternalDetailsCommand {
    return {
        'url': json['url'],
        'durationMinutes': json['durationMinutes'],
    };
}

export function AddOrUpdateTrainingProgramExternalDetailsCommandToJSON(value?: AddOrUpdateTrainingProgramExternalDetailsCommand | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'url': value.url,
        'durationMinutes': value.durationMinutes,
    };
}


